export const getSourceDocumentAttrs = (html) => {
    let project, documentId, area, excel;
    const hasTag = html?.indexOf("captis-link") > -1;

    if (hasTag) {
        const parser = new DOMParser();
        const htmlDoc = parser.parseFromString(html, "text/html");
        const el = htmlDoc.getElementsByClassName("captis-link")?.[0];

        if (el) {
            project = el?.getAttribute("data-project");
            documentId = el?.getAttribute("data-documentId");
            area = el?.getAttribute("data-area");
            excel = el?.getAttribute("data-excel");
        }
    }

    if (project && (area || excel)) {
        return { project, documentId, area, excel };
    }
};

export const getArticleLinkAttrs = (html) => {
    if (!html?.includes("captis-link")) {
        return;
    }

    const parser = new DOMParser();
    const htmlDoc = parser.parseFromString(html, "text/html");
    const el = htmlDoc.getElementsByClassName("captis-link")?.[0];

    if (!el || el.getAttribute("type") !== "article") {
        return;
    }

    const project = el.getAttribute("data-project");
    const articleId = el.getAttribute("data-articleid");
    const stage = el.getAttribute("data-stage");
    const articleType = el.getAttribute("data-articletype");
    const area = el.getAttribute("data-area");

    if (project && articleId && stage && articleType) {
        return { project, articleId, stage, articleType, area };
    }
};
